<template>
  <div class="container">
    <head-nav-bar :title="title" :fixed="true" style="z-index: 1000;" />
    <div class="doctor-info mt-header-nav">
      <div class="info">
        <doctor-card
          :data="info"
          :imgTag="false"
          :enabledDisplayDutyTitle="enabledDisplayDutyTitle"
        />
      </div>

      <van-tabs v-model="active">
        <van-tab title="挂号">
          <div v-if="date" class="time-list-box">
            <van-cell
              :title="'选择预约时间 (' + date + ')'"
              title-class="font-color-active"
            >
              <i slot="icon" class="iconfont icon-etc" />
            </van-cell>
            <div v-if="SettingList.sourceNoMode == 1" class="time-interval-box">
              <div
                class="time-interval-item"
                :class="{
                  disabled: timeType.amNum < 1,
                  active: currentTimeInterval === 0,
                }"
                @click="setCurrentTimeInterval(0)"
              >
                <div class="title">上午</div>
                <div class="text">剩余号源：{{ timeType.amNum }}</div>
                <i class="iconfont iconin_gouxuan"></i>
              </div>
              <div
                class="time-interval-item"
                :class="{
                  disabled: timeType.pmNum < 1,
                  active: currentTimeInterval === 1,
                }"
                @click="setCurrentTimeInterval(1)"
              >
                <div class="title">下午</div>
                <div class="text">剩余号源：{{ timeType.pmNum }}</div>
                <i class="iconfont iconin_gouxuan"></i>
              </div>
            </div>
            <div v-else class="date box">
              <van-radio-group v-model="activeTime">
                <van-radio
                  v-for="(item, index) in timeList"
                  :key="index"
                  :name="item.id"
                  class="radio-item"
                  >{{ item.text }}</van-radio
                >
              </van-radio-group>
            </div>
            <div class="box footer-actions">
              <van-button type="info" block @click="checked">确认</van-button>
            </div>
          </div>
          <div v-else>
            <van-cell title="选择预约日期" title-class="font-color-active">
              <i slot="icon" class="iconfont icon-etc" />
            </van-cell>
            <div class="date">
              <time-card-picker
                :data="timeSelectData"
                @change="onTimeSelected"
              />
            </div>
            <div class="box footer-actions">
              <van-button type="info" block @click="dateSelectPicker"
                >确认</van-button
              >
            </div>
          </div></van-tab
        >
        <van-tab title="介绍">
          <div
            v-if="info && info.desc"
            class="newstext"
            style="text-indent: 2em"
            v-html="info.desc"
          ></div>
          <div v-else class="newstext" style="text-indent: 2em">
            {{ info && info.remark }}
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import {
  List,
  Card,
  Tag,
  Button,
  Rate,
  Icon,
  Cell,
  Popup,
  CellGroup,
  RadioGroup,
  Radio,
  Tab,
  Tabs,
} from "vant";
import DoctorCard from "@/components/DoctorCard";
import TimeCardPicker from "@/components/TimeCardPicker";
import { formatDate, countDate } from "@/utils/common";
import SelectPicker from "@/components/select-picker/function";
import { mapState, mapActions } from "vuex";
import { cache } from "@/utils/common";

export default {
  name: "DoctorList",
  components: {
    DoctorCard,
    TimeCardPicker,
    [List.name]: List,
    [Card.name]: Card,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Rate.name]: Rate,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [Popup.name]: Popup,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },

  data() {
    return {
      title: "选择时间",
      Id: "",
      date: "",
      selectedDate: "",
      info: {},
      timeList: [],
      activeTime: "",
      active: "",
      timeSelectData: [],
      timeSelectModel: "",
      SettingList: {},
      currentTimeInterval: "",
      datePickerSelectedData: {},
      queueId: "",
      enabledDisplayDutyTitle: false,
    };
  },
  computed: {
    ...mapState({
      order: state => state.order,
    }),
    timeType() {
      const amNum = this.timeList.filter(p => p.timePeriodType == 0).length;
      const pmNum = this.timeList.filter(p => p.timePeriodType == 1).length;
      return {
        amNum,
        pmNum,
      };
    },
  },

  created() {
    this.queueId = this.$route.query.QueueId;
    this.date = this.$route.query.date;
    this.Id = this.$route.query.Id;
    if (!this.Id) {
      this.Id = this.order.DoctorId;
    }

    this.$post("GetWxSystemParameterInfo", {}).then(res => {
      const userInfo = cache.get("user");
      cache.set("user", { ...userInfo, ...res.data });
      this.SettingList = cache.get("user");
      this.enabledDisplayDutyTitle = res.data.enabledDisplayDutyTitle;
    });
    this.getInfo();
    if (this.date) {
      //获取日期的挂号数据
      this.loadTimeSelectData();
    } else {
      //获取日期段数据
      this.getWorkDate();
    }
  },
  beforeDestroy() {
    this.timeSelectModel && this.timeSelectModel.cancel();
  },
  mounted() {},
  methods: {
    ...mapActions(["setSourceNum"]),
    getInfo() {
      this.$post("Doctor_Info", {
        Id: this.Id != 0 ? this.Id : this.queueId,
      }).then(res => {
        this.info = res.data;
        this.info.enabledDisplayDutyTitle =
          this.SettingList.enabledDisplayDutyTitle && this.info.dutyTitle
            ? this.info.dutyTitle
            : this.info.professionalTitle;
      });
    },
    getWorkDate() {
      this.$post("Doctor_WorkDate", {
        DoctorId: this.Id,
        StartBookingDate: countDate(formatDate(), 1),
        EndBookingDate: countDate(formatDate(), 14),
      }).then(res => {
        console.log(res);
        this.timeSelectData = res.data;
      });
    },
    loadTimeSelectData() {
      // const arr = [];
      // for (let i = 0; i < 20; i++) {
      //   arr.push({
      //     id: i,
      //     text: "下午 03:40 - 03:45 剩余号数( " + i + " )"
      //   });
      // }
      // this.timeList = arr;
      this.$post("Doctor_SourceNum", {
        DoctorId: this.Id,
        WorkDate: this.date,
        QueueId: this.queueId,
      }).then(res => {
        const resData = res.data;
        if (resData && resData.length) {
          const arr = this.getSourceNumData(resData);
          this.timeList = arr;
          if (this.timeType.amNum > 0) {
            this.currentTimeInterval = 0;
          } else if (this.timeType.pmNum > 0) {
            this.currentTimeInterval = 1;
          }
        }
      });
    },
    onTimeSelected(data) {
      //请求可预约号的数据
      this.selectedDate = data.date;
      if (this.SettingList.sourceNoMode == 1) {
        // 上下午时段模式
        this.datePickerSelectedData = data;
        console.log(data);
      } else {
        this.$post("Doctor_SourceNum", {
          QueueId: this.queueId,
          DoctorId: this.Id,
          WorkDate: data.date,
          TimeType: data.type === "AM" ? "0" : "1",
        }).then(res => {
          const resData = res.data;
          if (resData && resData.length) {
            const arr = this.getSourceNumData(resData);
            const timeTypeName = data.type === "AM" ? "上午" : "下午";
            this.timeSelectModel = SelectPicker({
              columns: arr,
              change: this.dateSelectPicker,
              title: `${data.date} ( ${timeTypeName} )`,
            });
          } else {
            this.$notify("当前时段无号源");
          }
        });
      }
    },
    getSourceNumData(data) {
      const json = data.map(item => {
        item.text =
          item.timePeriodTypeDesc +
          "  " +
          item.workTimeStart +
          " - " +
          item.workTimeEnd +
          " 剩余号数 （" +
          item.sourceNum +
          ")";
        return item;
      });
      return json;
    },
    dateSelectPicker(data) {
      if (this.datePickerSelectedData.type == undefined && !data.text) {
        this.$notify("请选择号源");
        return;
      }
      if (this.SettingList.sourceNoMode == 1) {
        // 上下午时段模式
        this.$post("Doctor_SourceNum", {
          QueueId: this.queueId,
          DoctorId: this.Id,
          WorkDate: this.datePickerSelectedData.date,
          TimeType: this.datePickerSelectedData.type === "AM" ? 0 : 1,
        }).then(res => {
          if (res.data && res.data.length) {
            const resData = res.data[0];
            resData.treatmentDate = this.datePickerSelectedData.date;
            this.setSourceNum(resData);
            this.$router.push({ name: "servePreOrderConfirm" });
          } else {
            this.$notify("号源已占用，请重新选择");
            this.getWorkDate();
            return false;
          }
        });
      } else if (data) {
        data.treatmentDate = this.selectedDate;
        this.setSourceNum(data);
        this.$router.push({ name: "servePreOrderConfirm" });
      }
    },
    checked() {
      let data = {};
      if (this.SettingList.sourceNoMode == 1) {
        // 上下午时段模式
        if (this.currentTimeInterval === 0) {
          // 上午
          data = this.timeList[0];
        } else if (this.currentTimeInterval === 1) {
          // 下午
          const pmList = this.timeList.filter(p => p.timePeriodType == 1);
          data = pmList[0];
        } else {
          this.$notify("请选择预约时段");
          return false;
        }
      } else {
        if (!this.activeTime) {
          this.$notify("请选择预约时间");
          return false;
        }
        if (!this.timeList || this.timeList.length < 0) {
          this.$notify("没有号可以预约");
          return false;
        }
        const index = this.timeList.findIndex(
          item => item.id === this.activeTime,
        );
        data = this.timeList[index];
      }
      data.treatmentDate = this.date;
      this.setSourceNum(data);
      this.$router.push({ name: "servePreOrderConfirm" });
    },
    setCurrentTimeInterval(val) {
      const key = val === 0 ? "amNum" : "pmNum";
      if (this.timeType[key] > 0) {
        this.currentTimeInterval = val;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.time-list-box {
  padding-bottom: 100px;
  .date {
    //height: 8rem;
    overflow: hidden;
    // overflow-y: auto;
    .radio-item {
      font-size: 0.4rem;
      padding: 0.3rem;
      border-bottom: 1px solid #f1f1f1;
    }
  }
}
.time-interval-box {
  display: flex;
  .time-interval-item {
    flex: 1;
    margin: 10px;
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    position: relative;
    .title {
      font-size: 16px;
    }
    .text {
      color: #999;
    }
    .iconfont {
      display: none;
      position: absolute;
      bottom: -3px;
      right: 0;
      color: #1989fa;
      font-size: 30px;
    }
    &.disabled {
      background: #ddd;
    }
    &.active {
      border: 1px solid #1989fa;
      .iconfont {
        display: block;
      }
    }
  }
}
.footer-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
